import { environment as base } from './environment.prod';

export const environment = {
    ...base,
    appId: 'ca.haleo.screener.prod',
};
